import {UnsupportedNodeConverter} from './UnsupportedNodeConverter'

const UnsupportedInlineNodeConverter = {
    type: 'unsupportedinlinenode',

    matchElement: function() {
        return true
    },

    import: UnsupportedNodeConverter.import,
    export: UnsupportedNodeConverter.export
}

export {UnsupportedInlineNodeConverter}
